import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table";
import { Table, Row, Col, Button, Input } from "reactstrap";
import { DefaultColumnFilter, SelectColumnFilter, Filter, FilterRemote} from "./filters";
import JobListGlobalFilter from "./GlobalSearchFilter";

import toastr from "toastr";



// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <React.Fragment>
      <Col md={5}>
        <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Búsqueda
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value);
                  onChange(e.target.value);
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={`${count} registros...`}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>

      </Col>
      {isJobListGlobalFilter && (
        <JobListGlobalFilter />
      )}

    </React.Fragment>
  );
}

const TableContainerCustom = ({
  columns,
  data,
  isGlobalFilter,
  addBtnNewFlag,
  lblBtnAddNew,
  handleAddNewClick,
  customPageSize,
  className,
  serverSidePagination,
  addFilterCustomFlag,
  selectItems,
  handleFilterCumstom,
    onRemoteFilterChange // Nueva prop para manejar filtros remotos
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : "";
  };

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const handlePageChange = (newPage, search='') => {
    if (serverSidePagination) {
      serverSidePagination.onPageChange(newPage, search);
    } else {
      gotoPage(newPage - 1);
    }
  };
  return (
    <Fragment>
      <Row className="mb-2">
        {isGlobalFilter && (
            <GlobalFilter
                preGlobalFilteredRows={preGlobalFilteredRows}
                globalFilter={state.globalFilter}
                setGlobalFilter={setGlobalFilter}
                isJobListGlobalFilter={isJobListGlobalFilter}
            />
        )}
        <Col sm="6">
        {
          addFilterCustomFlag && 
          <select className="form-select" id="custom-select" onChange={ e => handleFilterCumstom('area_id', e.target.value)}>
            <option value="">All</option>
            {selectItems?.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
            </select>
        }
        </Col>
        {addBtnNewFlag && (
          <Col sm="6">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded  mb-2 me-2"
                onClick={handleAddNewClick}
              >
                <i className="mdi mdi-plus me-1" />
                {lblBtnAddNew}
              </Button>
            </div>
          </Col>
        )}
      </Row>


        <Table bordered hover {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th data-priority={column.id} key={column.id}>
                    <div className="mb-0" {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                    <Filter column={column } onRemoteFilterChange={onRemoteFilterChange} />
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Fragment key={index}>
                  <tr key={index}>
                    {row.cells.map(cell => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </Table>


      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              //onClick={() => gotoPage(0)} 
              onClick={() => handlePageChange(1)}
            disabled={serverSidePagination ? serverSidePagination.currentPage === 1 : !canPreviousPage}
              //disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>
            <Button
              color="primary"
              //onClick={previousPage}
              //disabled={!canPreviousPage}
              onClick={() => handlePageChange(serverSidePagination ? serverSidePagination.currentPage - 1 : pageIndex)}
              disabled={serverSidePagination ? serverSidePagination.currentPage === 1 : !canPreviousPage}
            >
              {"<"}
            </Button>
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page{" "}
          <strong>

            {serverSidePagination ? serverSidePagination.currentPage : pageIndex + 1} of{" "}
            {serverSidePagination 
            ? Math.ceil(serverSidePagination.totalItems / state.pageSize)
            : pageOptions.length}
          </strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="number"
            min={1}
            style={{ width: 70 }}
            max={pageOptions.length}
            defaultValue={pageIndex + 1}
            onChange={onChangeInInput}
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button color="primary" 
            ///onClick={nextPage} 
            //disabled={!canNextPage}
            onClick={() => handlePageChange(serverSidePagination ? serverSidePagination.currentPage + 1 : pageIndex + 2)}
            disabled={serverSidePagination 
              ? serverSidePagination.currentPage >= Math.ceil(serverSidePagination.totalItems / state.pageSize)
              : !canNextPage}
            >
              {">"}
            </Button>
            <Button
              color="primary"
              //onClick={() => gotoPage(pageCount - 1)}
              //disabled={!canNextPage}
              onClick={() => handlePageChange(serverSidePagination 
                ? Math.ceil(serverSidePagination.totalItems / state.pageSize)
                : pageCount)}
              disabled={serverSidePagination
                ? serverSidePagination.currentPage >= Math.ceil(serverSidePagination.totalItems / state.pageSize)
                : !canNextPage}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

TableContainerCustom.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainerCustom;
